Vendd.Scripts.load(function () {
    var $wrapper = $('.brand-list');

});

